import { render, staticRenderFns } from "./DataDetailTableComponent.vue?vue&type=template&id=6890b57a&scoped=true&"
import script from "./DataDetailTableComponent.vue?vue&type=script&lang=js&"
export * from "./DataDetailTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataDetailTableComponent.vue?vue&type=style&index=0&id=6890b57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890b57a",
  null
  
)

export default component.exports